
// @ts-nocheck
/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import moment from 'moment';

import authAxios from '../authorization/axios';


const getPlanetPriceInDate = async (date: Date) => {
  const result = await axios.get(`https://api.coingecko.com/api/v3/coins/planetwatch/history?date=${moment(date).format('DD-MM-YYYY')}`);
  return result.data.market_data?.current_price;
}

const getAlgorandPriceInDate = async (date: Date) => {
  const result = await axios.get(`https://api.coingecko.com/api/v3/coins/algorand/history?date=${moment(date).format('DD-MM-YYYY')}`);
  return result.data.market_data?.current_price;
}

const replaceChangeMailOrder = async (
  orderId: number,
  submitData,
  constants
): Promise<AxiosResponse<any>> => {
  const res = await authAxios.post(constants.api.changeMailOrder.replace('{orderId}', String(orderId)), submitData)
  return res;
};
const loadCounts = async (constants: object): Promise<AxiosResponse<any>> => {
  try {
    const res = await authAxios.get(`${constants.api.getPurchasesCounts}`);
    return res;
  } catch (err: any) {
    console.log(err);
    return err;
  }
};
const deleteOrderCall = async (id: number, constants: object): Promise<AxiosResponse<any>> => {
  try {
    const res = await authAxios.delete(`${constants.api.deleteOrder}/${id}`);
    return res
  } catch (err: any) {
    console.log(err)
    return err;
  }
};

const downloadCreditNoteHandler = async (url: string) => {
  try {
    const res = await authAxios.get(url);
    return res;
  } catch (err) {
    return err;
  }
}

const downloadInvoiceHandler = async (url: string, setLoading): Promise<AxiosResponse<any>> => {
  try {
    const res = await authAxios.get(url);
    return res;

  } catch (err: any) {
    return err;
  };
}

export {
  getPlanetPriceInDate,
  getAlgorandPriceInDate,
  replaceChangeMailOrder,
  loadCounts,
  deleteOrderCall,
  downloadCreditNoteHandler,
  downloadInvoiceHandler
};